import React, { useEffect, useRef } from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import Header from "./landingPage/Header";
import SiteCtaAndFooter from "./landingPage/SiteCtaAndFooter";
import "./Free50Signup.css";

const KIT_UID = "7b3d2b2205";
const KIT_SCRIPT_SRC = `https://qurania.kit.com/${KIT_UID}/index.js`;

export default function Free50Signup() {
  const mountRef = useRef(null);

  useEffect(() => {
    if (document.querySelector(`script[data-uid="${KIT_UID}"]`)) {
      return;
    }
    const el = mountRef.current;
    if (!el) return;

    const script = document.createElement("script");
    script.async = true;
    script.dataset.uid = KIT_UID;
    script.src = KIT_SCRIPT_SRC;
    el.appendChild(script);
  }, []);

  return (
    <>
      <Helmet>
        <title>Claim your free reward – Qurania</title>
        <meta
          name="description"
          content="Sign up with your email to get your Qurania incentive and start learning Quranic Arabic."
        />
        <link rel="canonical" href="https://www.quranstories.pro/free50" />
        <meta property="og:title" content="Claim your free reward – Qurania" />
        <meta
          property="og:description"
          content="Join with your email to receive your incentive from Qurania."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.quranstories.pro/free50" />
      </Helmet>
      <Header />
      <main className="free50-page">
        <div className="free50-inner">
        <h1 className="free50-title">Your Free Gift Awaits</h1>
<p className="free50-subtitle">
  Enter your email below to receive your free book; a small gift from the Qurania team to support your journey with the Quran.
</p>
<p className="free50-note">
  If you don’t see the email right away, please check your spam or promotions folder.
</p>
          <div
            id="free50-kit-mount"
            className="free50-kit-mount"
            ref={mountRef}
          />
          <nav className="free50-internal-nav" aria-label="Related Qurania pages">
            <p className="free50-internal-nav-title">More to explore</p>
            <ul>
              <li>
                <Link to="/free">All free resources</Link>
              </li>
              <li>
                <Link to="/blog/most-common-words-quran">Most common words in the Quran</Link>
              </li>
              <li>
                <Link to="/learn-quranic-arabic">Learn Quranic Arabic with Qurania</Link>
              </li>
            </ul>
          </nav>
        </div>
      </main>
      <SiteCtaAndFooter downloadTrackingPage="free50" />
    </>
  );
}
